import React from 'react';
import useStyles from './style';

const OrderNotification = ({ count, onClose }) => {
    const classes = useStyles();
    if (count <= 0) return null;

    return (
        <div className={classes.container}>
            <div className={classes.notification}>
                <button type="button" className={classes.closeButton} onClick={onClose}>
                    ×
                </button>
                <div className={classes.content}>
                    <div className={classes.icon}>⚠️</div>
                    <div className={classes.text}>
                        <strong className={classes.title}>Order Belum Dikonfirmasi</strong>
                        <p className={classes.message}>
                            Anda memiliki
                            {' '}
                            {count}
                            {' '}
                            order yang belum dikonfirmasi.
                        </p>
                        <a href="/sales/shipment" className={classes.link}>
                            Klik di sini untuk melihat →
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderNotification;
